import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import {
  TEMP_PASSWORD_FOR_COHORTS,
  COHORT_PASSWORD_MIN_LENGTH,
} from '../../../../../constants/general';

import type { ChangeEvent } from 'react';

type UseSubmitCohortPasswordModalArgs = {
  open: boolean;
  onClose: () => void;
  onPasswordVerified: () => void;
};

export default function useSubmitCohortPasswordModal({
  open,
  onClose,
  onPasswordVerified,
}: UseSubmitCohortPasswordModalArgs) {
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (!open) {
      setPassword('');
    }
  }, [open]);

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const handleConfirmSubmit = () => {
    if (password !== TEMP_PASSWORD_FOR_COHORTS) {
      toast.error('Invalid password');
      return;
    }
    onPasswordVerified();
    onClose();
  };

  return {
    password,
    handlePasswordChange,
    handleConfirmSubmit,
    isSubmitDisabled: password.length < COHORT_PASSWORD_MIN_LENGTH,
  };
}
